export default __webpack_public_path__ + "static/media/single user.ffca6e27.svg";